import { render } from "./Closer.vue?vue&type=template&id=272e48b1"
import script from "./Closer.vue?vue&type=script&lang=js"
export * from "./Closer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__